import React from "react";
import FavoriteCard from "../components/FavoriteCard";
import { useSelector } from "react-redux";

const FavoriteFilm = () => {
  const { favorite } = useSelector((state) => state.favoriteReducer);
  return (
    <>
      {favorite.length === 0 ? (
        <h5 style={{ marginTop: "300px" }}>Favorite Movie is Empty</h5>
      ) : (
        <div className="container" style={{ marginTop: "40px" }}>
          <div className="row">
            {favorite.map((favorite, idx) => (
              <FavoriteCard key={idx} favorite={favorite} />
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export default FavoriteFilm;
